import React, { useState, useEffect, useContext } from 'react';
import { Container, Paper, IconButton, Box, Button } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import Loader from '../components/loader';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import * as endPoints from '../assets/js/endpoints';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../assets/contexts/userContext';
import AddIcon from '@mui/icons-material/Add';
import { Helmet } from 'react-helmet';

const EmployeeArticles = () => {
  const { user } = useContext(UserContext);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const fetchArticles = async () => {
    if (!user.id) return;
    try {
      setLoading(true);
      const data = await endPoints.getArticlesbyUserId(user.id);
      const list = Array.isArray(data) ? data : data.data;
      setArticles(list);
      if (list.length === 0) {
        showNotification('Aún no tienes artículos', 'info');
      }
    } catch (error) {
      showNotification('Error al obtener artículos', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [user.id]);

  const handleDelete = async id => {
    const ok = await confirm('¿Eliminar artículo?');
    if (!ok) return;
    try {
      setLoading(true);
      await endPoints.deleteArticle(id);
      await fetchArticles();
      showNotification('Artículo eliminado', 'success');
    } catch (error) {
      showNotification('Error eliminando artículo', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = id => {
    navigate(`/blog/editar/${id}`);
  };

  const handleView = id => {
    navigate(`/blog/${id}`);
  };

  const handleCreate = () => {
    navigate('/blog/createArticle');
  };

  if (loading) return <Loader />;

  const columns = [
    { id: 'title', label: 'Título' },
    { id: 'serviceName', label: 'Servicio' },
  ];

  const rows = articles.map(a => ({ ...a, serviceName: a.service?.name || a.service?.title }));

  const actions = article => (
    <>
      <IconButton onClick={() => handleView(article.id)} sx={{ color: ACTION_ICON_COLORS.see }}>
        <VisibilityIcon />
      </IconButton>
      <IconButton onClick={() => handleEdit(article.id)} sx={{ color: ACTION_ICON_COLORS.edit }}>
        <EditIcon />
      </IconButton>
      <IconButton onClick={() => handleDelete(article.id)} sx={{ color: ACTION_ICON_COLORS.delete }}>
        <DeleteIcon />
      </IconButton>
    </>
  );

  return (
    <>
      <Helmet>
        <title>Mis Artículos | CES</title>
      </Helmet>
      <Container sx={{ mt: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <PageTitle>Mis Artículos</PageTitle>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Crear Nuevo Artículo</Button>
        </Box>
        <DataTable columns={columns} rows={rows} actions={actions} />
      </Container>
    </>
  );
};

export default EmployeeArticles;
